import { Users, ShieldCheck, KeyRound, AlertTriangle } from 'lucide-react';

interface Props {
  totalUsers: number;
  roles: number;
  mfaCoveragePct: number;
  criticalAccessViolations: number;
  compact?: boolean;
}

export function RbacAuditSummary({ totalUsers, roles, mfaCoveragePct, criticalAccessViolations, compact = false }: Props) {
  const items = [
    { label: 'Total Users',                value: totalUsers.toLocaleString(),     icon: Users,         tone: 'text-[#58a6ff]' },
    { label: 'Roles',                      value: roles.toLocaleString(),          icon: KeyRound,      tone: 'text-[#4ec9ff]' },
    { label: 'MFA Coverage',               value: `${mfaCoveragePct}%`,            icon: ShieldCheck,   tone: 'text-[#9b8cff]' },
    { label: 'Critical Access Violations', value: criticalAccessViolations.toString(), icon: AlertTriangle, tone: criticalAccessViolations === 0 ? 'text-[#43e6d0]' : 'text-bad' },
  ];

  return (
    <div className={compact ? 'rounded-md border border-[#19395a] bg-[#071d31] p-2.5' : 'card'}>
      <div className="text-[12px] font-semibold text-[#dbe7f3] mb-2">RBAC Audit Summary</div>
      <div className="grid grid-cols-4 gap-1.5">
        {items.map((it) => (
          <div key={it.label} className="bg-[#0b2035] border border-[#19395a] rounded-md px-1 py-2 text-center min-h-[67px]">
            <it.icon className={`w-[17px] h-[17px] ${it.tone} mx-auto mb-1`} />
            <div className={`text-[15px] leading-none font-extrabold ${it.tone}`}>{it.value}</div>
            <div className="text-[8px] leading-tight text-[#b5c4d4] mt-1">{it.label}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
